import { render, staticRenderFns } from "./GestioneScadenze.vue?vue&type=template&id=1adf2960&"
import script from "./GestioneScadenze.vue?vue&type=script&lang=js&"
export * from "./GestioneScadenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports